<template>

  <div class="yulan_wrap invoice_wrap">

    <!--公共样式部分 发票类型 发票状态 灰层-->
    <div class="invoice_base">
      <p class="invoice_type_car">
        <!--<span id="invoiceType">普</span>-->
      </p>
      <span
        :class="['invoice_state',invoiceState]"
        id="invoiceState"
      ></span>
      <!--异常：abnormal，失控：outcontrol，红冲：red，作废：void-->

      <i class="iconfont icon-yinzhang check_result_icon"></i>
    </div>

    <div class="cms_r_main">

      <h1 class="invoice_tit"><span id="invoiceTit">
          {{invoiceData.invoiceType || "二手车销售统一发票"}}
        </span></h1>
      <table
        style="width: 100%;"
        border="0"
        cellspacing="0"
        cellpadding="0"
      >
        <tbody>
          <tr height="30">
            <td class="align_left">发票代码：<span
                class="content_td_blue"
                id="invoiceCode"
              >
                {{invoiceData.invoiceCode}}
              </span></td>
            <td>&nbsp;</td>
            <td class="align_left">发票号码：<span
                class="content_td_blue"
                id="invoiceNumber"
              >
                {{invoiceData.invoiceNumber}}
              </span></td>
            <td>&nbsp;</td>
            <td class="align_left">开票日期：<span
                class="content_td_blue"
                id="billingDate"
              >{{farmatData(invoiceData.billingDate)}}</span></td>
            <td>&nbsp;</td>
            <td class="align_left">&nbsp;</td>
            <td>&nbsp;</td>
          </tr>
        </tbody>
      </table>
      <table
        class="fppy_table"
        style="width: 100%;"
        border="0"
        cellspacing="0"
        cellpadding="0"
      >
        <tbody>
          <tr>
            <td class="align_center">
              <p>机 打 代 码</p>
              <p>机 打 号 码</p>
              <p>机 器 编 号</p>
            </td>
            <td
              class="align_left"
              nowrap=""
              colspan="1"
            >
              <p
                class="content_td_blue"
                id="jddm_invoiceCode"
              >
                {{invoiceData.invoiceCode}}
              </p>
              <p
                class="content_td_blue"
                id="jdhm_invoiceNumber"
              >
                {{invoiceData.invoiceNumber}}

              </p>
              <p
                class="content_td_blue"
                id="machineCode"
              >{{invoiceData.machineCode}}</p>
            </td>
            <td class="align_center">
              <p>税</p>
              <p>控</p>
              <p>码</p>
            </td>
            <td
              class="align_center"
              colspan="6"
            >&nbsp;</td>
          </tr>
          <tr>
            <td class="align_center">
              <p>买方单位／个人</p>
            </td>
            <td
              class="align_left"
              nowrap=""
              colspan="1"
            >
              <p
                class="content_td_blue"
                id="purchaserName"
              >
                {{invoiceData.purchaserName}}
              </p>
            </td>
            <td
              class="align_center"
              colspan="3"
            >单位代码／身份证号码</td>
            <td
              class="align_left"
              colspan="4"
            >
              <p
                class="content_td_blue"
                id="purchaserTaxNo"
              >
                {{invoiceData.purchaserTaxNo}}
              </p>
            </td>
          </tr>
          <tr>
            <td class="align_center">
              <p>买方单位／个人住址</p>
            </td>
            <td
              class="align_left"
              nowrap=""
              colspan="5"
            ><span
                class="content_td_blue"
                id="purchaserAddress"
              >
                {{invoiceData.purchaserAddress}}
              </span></td>
            <td
              class="align_center"
              nowrap=""
            >电话</td>
            <td
              class="align_left"
              colspan="3"
            >
              <p
                class="content_td_blue"
                id="purchaserPhone"
              >
                {{invoiceData.purchaserPhone}}
              </p>
            </td>
          </tr>
          <tr>
            <td class="align_center">
              <p>卖方单位／个人</p>
            </td>
            <td
              class="align_left"
              nowrap=""
              colspan="1"
            >
              <p
                class="content_td_blue"
                id="salesName"
              >
                {{invoiceData.salesName}}
              </p>
            </td>
            <td
              class="align_center"
              colspan="3"
            >单位代码／身份证号码</td>
            <td
              class="align_left"
              colspan="4"
            >
              <p
                class="content_td_blue"
                id="salesTaxNo"
              >
                {{invoiceData.salesTaxNo}}
              </p>
            </td>
          </tr>
          <tr>
            <td class="align_center">
              <p>卖方单位／个人住址</p>
            </td>
            <td
              class="align_left"
              nowrap=""
              colspan="5"
            >
              <span
                class="content_td_blue"
                id="salesAddress"
              >
                {{invoiceData.salesAddress}}
              </span>
            </td>
            <td
              class="align_center"
              nowrap=""
            >电话</td>
            <td
              class="align_left"
              colspan="3"
            >
              <p
                class="content_td_blue"
                id="salesPhone"
              >
                {{invoiceData.salesPhone}}
              </p>
            </td>
          </tr>
          <tr>
            <td
              class="align_center"
              colspan="1"
            >车牌照号</td>
            <td
              class="align_left"
              colspan=""
            ><span
                class="content_td_blue"
                id="carNumber"
              >
                {{invoiceData.carNumber}}
              </span></td>
            <td
              class="align_center"
              colspan="1"
            >登记证号</td>
            <td
              class="align_left"
              colspan="2"
            ><span
                class="content_td_blue"
                id="registrationNumber"
              >
                {{invoiceData.registrationNumber}}
              </span></td>
            <td
              class="align_center"
              colspan="2"
            >车辆类型</td>
            <td
              class="align_left content_td_blue"
              id="vehicleType"
              colspan="3"
            >
              {{invoiceData.vehicleType}}
            </td>
          </tr>
          <tr>
            <td
              class="align_center"
              colspan="1"
            >车价号／车辆识别代码</td>
            <td class="align_left"><span
                class="content_td_blue"
                id="vehicleNo"
              >
                {{invoiceData.vehicleNo}}
              </span>
            </td>
            <td
              class="align_center"
              colspan="1"
            >厂牌型号</td>
            <td
              class="align_left"
              colspan="2"
            ><span
                class="content_td_blue"
                id="brandModel"
              >
                {{invoiceData.brandModel}}
              </span></td>
            <td
              class="align_left"
              colspan="2"
              nowrap
            >
              <p>转入地车辆</p>
              <p>管理所名称</p>
            </td>
            <td
              class="align_left content_td_blue"
              id="vehiclePlaceName"
              colspan="2"
            >
              {{invoiceData.vehiclePlaceName}}
            </td>
          </tr>
          <tr>
            <td class="align_center">
              <p>车价合计（大写）</p>
            </td>
            <td
              class="align_left"
              nowrap=""
              colspan="5"
            ><span
                class="content_td_blue"
                id="totalPriceCN"
              >
                ⊗ {{invoiceData.totalPriceCn}}
              </span></td>
            <td
              class="align_center"
              nowrap=""
            >小写</td>
            <td
              class="align_left"
              colspan="3"
            >
              <p
                class="content_td_blue"
                id="totalPrice"
              >

                ￥ {{invoiceData.totalPrice}}
              </p>
            </td>
          </tr>
          <tr>
            <td class="align_center">
              <p>经营、拍卖单位</p>
            </td>
            <td
              class="align_left"
              nowrap=""
              colspan="9"
            ><span
                class="content_td_blue"
                id="auctionName"
              >
                {{invoiceData.auctionName}}
              </span></td>
          </tr>
          <tr>
            <td class="align_center">
              <p>经营、拍卖单位地址</p>
            </td>
            <td
              class="align_left"
              nowrap=""
              colspan="2"
            >
              <span
                class="content_td_blue"
                id="auctionAddress"
              >
                {{invoiceData.auctionAddress}}
              </span>
            </td>
            <td
              class="align_center"
              nowrap=""
              colspan="2"
            >
              <p>纳税人</p>
              <p>识别号</p>
            </td>
            <td
              class="align_left"
              colspan="4"
            >
              <p
                class="content_td_blue"
                id="auctionTaxNo"
              >

                {{invoiceData.auctionTaxNo}}
              </p>
            </td>
          </tr>
          <tr>
            <td class="align_center">开户银行、账号</td>
            <td
              class="align_left content_td_blue"
              id="auctionBank"
              nowrap=""
              colspan="4"
            >
              {{invoiceData.auctionBank}}
            </td>
            <td
              class="align_center"
              nowrap=""
            >电话</td>
            <td
              class="align_left content_td_blue"
              id="auctionPhone"
              nowrap=""
              colspan="4"
            >
              {{invoiceData.auctionPhone}}
            </td>
          </tr>
          <tr style='height:26px'>
            <td
              class="align_center"
              width="30%"
              rowspan="2"
              style='border:1px solid #dddee1;border-top-width: 0'
            >
              二 手 车 市 场
            </td>
            <td
              class="align_left"
              nowrap=""
              width="50%"
              rowspan="2"
              style='border:1px solid #dddee1;border-top-width: 0'
            >
              <p
                class="content_td_blue"
                id="usedCarName"
              >
                {{invoiceData.usedCarName}}
              </p>
            </td>
            <td
              class="align_center"
              width="12%"
              style='border:1px solid #dddee1;border-top-width: 0'
            >
              <p>纳 税 人</p>
              <p>识 别 号</p>
            </td>
            <td
              class="align_left"
              width="50%"
              style='border:1px solid #dddee1;border-top-width: 0'
              colspan="6"
            >
              <p
                class="content_td_blue"
                id="usedCarTaxNo"
              >
                {{invoiceData.usedCarTaxNo}}
              </p>
            </td>
          </tr>
          <tr style='height:26px'>
            <td
              class="align_center"
              width="12%"
              style='border:1px solid #dddee1;border-top-width: 0'
            >
              地 址
            </td>
            <td
              class="align_left"
              width="13%"
              style='border:1px solid #dddee1;border-top-width: 0'
              colspan="6"
            >
              <p
                class="content_td_blue"
                id="usedCarAddress"
              >
                {{invoiceData.usedCarAddress}}
              </p>
            </td>
          </tr>
          <tr>
            <td class="align_center">开户银行、账号</td>
            <td
              class="align_left content_td_blue"
              id="usedCarbank"
              nowrap=""
              colspan="4"
            >
              {{invoiceData.usedCarBank}}
            </td>
            <td
              class="align_center"
              nowrap=""
            >电话</td>
            <td
              class="align_left content_td_blue"
              id="usedCarPhone"
              nowrap=""
              colspan="4"
            >
              {{invoiceData.usedCarPhone}}
            </td>
          </tr>
          <tr>
            <td class="align_center">
              <p>备注：</p>
            </td>
            <td
              class="align_left"
              nowrap=""
              colspan="9"
            ><span
                class="content_td_blue"
                id="remarks"
                v-html="invoiceData.remarks"
              >
                <!-- {{invoiceData.remarks}} -->
              </span></td>
          </tr>
          <!--表头-->
          <!--表头结束-->
        </tbody>
      </table>
    </div>

  </div>
</template>
<script>
import moment from 'moment';

export default {
  name: 'invoiceCarSecond',
  data() {
    return {
      invoiceConClass: true,
    };
  },
  props: ['invoiceData', 'invoiceState', 'invoiceType', 'invoiceTit'],
  mounted() {
  },
  methods: {
    farmatData(date) {
      if (!date) return '';
      console.log('date===', date);
      return moment(date).format('YYYY 年 MM 月 DD 日');
    },
  },
};
</script>
<style scoped  src="../invoice.css"></style>
<style scoped  src="../checkResult.css"></style>
<style  scoped>
.invoice_wrap {
  font-size: 10px;
}
</style>
